import React, { useState } from 'react';
import { CheckCircle2, Phone } from 'lucide-react';
import { CommercialQuoteForm } from '../../components/CommercialQuoteForm/CommercialQuoteForm';
export function HeroQuotePanel() {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitted(true);
  };
  return <div className="lg:col-span-5 relative z-10 w-full max-w-md mx-auto lg:max-w-none anim-fade-scale" style={{
    animationDelay: '0.2s'
  }} id="quote-form" data-id="element-552">
      <div className="bg-white rounded-md shadow-[0_4px_20px_rgba(0,0,0,0.08)] border border-neutral-200 p-5 sm:p-6" data-id="element-553">
        <div className="inline-block bg-primary-600 text-white font-semibold text-[11px] tracking-widest uppercase px-3 py-1 rounded-sm mb-3" data-id="element-554">
          Free Commercial Estimate
        </div>
        <h2 className="kosins-heading text-2xl text-neutral-900 mb-1.5 leading-tight" data-id="element-555">
          Request a Commercial Glass Quote
        </h2>
        <p className="text-xs text-neutral-500 mb-4 leading-relaxed font-sans" data-id="element-556">
          Submit your details and a Kosin's Glass team member will contact you
          to confirm company, project address, photos, dimensions, timeline and
          bid requirements.
        </p>

        {isSubmitted ? <div className="bg-primary-50 border border-primary-200 rounded-md p-5 text-center" data-id="element-557">
            <div className="w-10 h-10 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-3" data-id="element-558">
              <CheckCircle2 className="w-5 h-5 text-primary-600" data-id="element-559" />
            </div>
            <h3 className="kosins-heading text-lg text-neutral-900 mb-1" data-id="element-560">
              Request Received
            </h3>
            <p className="text-neutral-700 text-xs font-sans" data-id="element-561">
              Thank you. A commercial glass specialist will contact you shortly.
            </p>
          </div> : <CommercialQuoteForm onSubmit={handleSubmit} data-id="element-562" />}

        <div className="mt-4 pt-4 border-t border-neutral-100 text-center font-sans" data-id="element-563">
          <p className="text-xs text-neutral-600 flex items-center justify-center gap-1.5 mb-1" data-id="element-564">
            Prefer to call? <Phone className="w-3.5 h-3.5 text-primary-600" data-id="element-565" />{' '}
            <a href="tel:5175457772" className="font-bold text-neutral-900 hover:text-primary-600 transition-colors" data-id="element-566">
              517-545-7772
            </a>
          </p>
          <p className="text-[10px] text-neutral-400" data-id="element-567">
            We respect your privacy. Your details are safe with us.
          </p>
        </div>

        {/* Micro-testimonial */}
        <div className="mt-4 pt-4 border-t border-neutral-100 font-sans" aria-label="Customer review, 5-star rating" data-id="element-568">
          <div className="flex items-center gap-0.5 text-amber-500 mb-1.5" aria-hidden="true" data-id="element-569">
            {[0, 1, 2, 3, 4].map(i => <svg key={i} className="w-3 h-3 fill-current" viewBox="0 0 20 20" data-id="element-570">
                <path d="M10 1.5l2.6 5.3 5.9.9-4.3 4.1 1 5.8L10 14.9 4.8 17.6l1-5.8L1.5 7.7l5.9-.9z" data-id="element-571" />
              </svg>)}
          </div>
          <p className="text-xs text-neutral-600 italic leading-relaxed" data-id="element-572">
            "[Paste real customer review here.]"
          </p>
          <p className="text-[10px] text-neutral-500 mt-1 not-italic" data-id="element-573">
            [Customer Name], [City]
          </p>
        </div>
      </div>
    </div>;
}